module.exports = __webpack_public_path__ + "img/Maker.7b792052.jpeg";